/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BaseInternalError } from '../base-internal-error';
import { ErrorNames } from '../../enums';

export class ValidationInternalError extends BaseInternalError {

    constructor(property: string) {
        super(`Unexpected error: Property ${property} is required.`);

        this.name = ErrorNames.ValidationInternalError;
    }

}
